export default "__VITE_ASSET__DeXfLzj6pWgslXT5yi_ZZw__"